import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/** Sets `document.title` as "<page> · Solution Advisor"; page.viewed events capture it. */
export const usePageTitle = (pageTitle?: string) => {
	const { t } = useTranslation();
	useEffect(() => {
		document.title = pageTitle ? `${pageTitle} · ${t("app.title")}` : t("app.title");
	}, [pageTitle, t]);
};
